/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CurrencyQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("CurrencyQueryOperator");
    }

    getFixupPrototypeFunction() { return CurrencyQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<CurrencyQueryOperator>): CurrencyQueryOperator {
        let obj = Object.assign(new CurrencyQueryOperator(), model);
        CurrencyQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CurrencyQueryOperator>): CurrencyQueryOperator {
        if (!model) return null;
        return CurrencyQueryOperator.newInstance(<CurrencyQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CurrencyQueryOperator) {
        if (!obj) return;

        models.CurrencyQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CurrencyQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CurrencyQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Currencies to include
     */
    currencies: Array<models.Currency>;

}
